import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  redirectPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  redirectPath = '/onboarding'
}) => {
  const { isAuthenticated, isAuthReady, isInactive } = useAuth();

  if (!isAuthReady) {
    return null;
  }

  // Redirect to onboarding if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  // Redirect to PIN lock screen if inactive
  if (isInactive) {
    return <Navigate to="/pin-lock" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
